import { render, staticRenderFns } from "./AccessRequest.vue?vue&type=template&id=358f89a6&scoped=true"
import script from "./AccessRequest.vue?vue&type=script&lang=js"
export * from "./AccessRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358f89a6",
  null
  
)

export default component.exports